module.exports = __webpack_public_path__ + "img/headerUrl.59ec44ae.png";